import {
  ref,
  readonly,
  useContext
} from "@nuxtjs/composition-api";
import fetch from "isomorphic-fetch";
import { useApi } from "@wemade-vsf/composables";
import companyExistsGql from "./companyExists.gql";
const BRREG_BASE = "https://data.brreg.no/enhetsregisteret/api/enheter/";
function useCompanyRegistration() {
  const loading = ref(false);
  const error = ref({
    getCompanyData: null,
    checkCompany: null,
    registerCompany: null
  });
  const { app } = useContext();
  const { query } = useApi();
  const getCompanyData = async (orgNo) => {
    var _a, _b;
    let result = null;
    try {
      loading.value = true;
      const response = await fetch(BRREG_BASE + orgNo.replace(/[\s]+/g, ""));
      if (response.status >= 200 && response.status <= 299) {
        const data = await response.json();
        result = {
          orgNo: data.organisasjonsnummer,
          name: data.navn,
          address1: data.forretningsadresse.adresse.length > 0 ? data.forretningsadresse.adresse[0] : "",
          address2: (_b = (_a = data.forretningsadresse.adresse) == null ? void 0 : _a[1]) != null ? _b : "",
          postcode: data.forretningsadresse.postnummer,
          city: data.forretningsadresse.poststed,
          bancrupt: data.konkurs || data.underAvvikling
        };
      } else {
        throw new Error("Unable to find company");
      }
      error.value.getCompanyData = null;
    } catch (err) {
      error.value.getCompanyData = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  const checkCompany = async (orgNo) => {
    var _a, _b;
    orgNo = orgNo.replace(/[\s]+/g, "");
    let result = null;
    try {
      loading.value = true;
      const { data } = await query(companyExistsGql, { orgNo });
      if (((_a = data == null ? void 0 : data.WmCompanyExists) == null ? void 0 : _a.exists) === false)
        result = false;
      if (((_b = data == null ? void 0 : data.WmCompanyExists) == null ? void 0 : _b.exists) === true)
        result = true;
      error.value.checkCompany = null;
    } catch (err) {
      error.value.checkCompany = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  const registerCompany = async (input) => {
    var _a;
    let result = false;
    try {
      loading.value = true;
      const { data } = await app.$vsf.$magento.api.createCompany(input);
      result = (_a = data == null ? void 0 : data.createCompany) == null ? void 0 : _a.message.startsWith("Success");
      error.value.registerCompany = null;
    } catch (err) {
      error.value.registerCompany = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  return {
    loading: readonly(loading),
    error: readonly(error),
    getCompanyData,
    checkCompany,
    registerCompany
  };
}
export {
  useCompanyRegistration
};
